export default __webpack_public_path__ + "static/Vol 3 - TA 10A - TCP (with appendices)-1febf8331a0ea5967ba7c26445a3c2f5.pdf";